import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../../data/site";

const WhatsAppFab = () => (
  <a
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label="Chat on WhatsApp"
    className="wa-pulse fixed bottom-6 right-6 z-[70] hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110 md:flex"
  >
    <MessageCircle className="h-6 w-6" strokeWidth={2} />
  </a>
);

export default WhatsAppFab;
